import {
  bg_default,
  bg_default_hover,
  bg_neutral_inset,
  bg_neutral_inset_hover,
  border_default,
  border_subtle,
  fg_default,
  fg_muted,
} from "@clockwise/design-system/tokens";
import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
import React from "react";
import { CalendarMode } from "..";

const useStyles = makeStyles({
  selected: {
    backgroundColor: bg_default,
    ":hover": {
      backgroundColor: bg_default_hover,
    },
    color: fg_default,
    border: "1px solid",
    borderColor: border_default,
  },

  unselected: {
    backgroundColor: bg_neutral_inset,
    ":hover": {
      backgroundColor: bg_neutral_inset_hover,
    },
    color: fg_muted,
    border: "1px solid",
    borderColor: border_subtle,
  },
});

export const CalendarModeToggle = ({
  calendarMode,
  onCalendarModeChange,
}: {
  calendarMode: CalendarMode;
  onCalendarModeChange: (view: CalendarMode) => void;
}) => {
  const weekSelected = calendarMode === "week";
  const classes = useStyles();
  return (
    <div aria-label="calendar mode toggle" className="cw-flex">
      <button
        onClick={() => onCalendarModeChange("day")}
        className={classNames(
          "cw-body-sm cw-py-[3px] cw-w-[70px] cw-cursor-pointer cw-rounded-l-md cw-font-medium",
          {
            [classes.selected]: !weekSelected,
            [classes.unselected]: weekSelected,
          },
        )}
      >
        Day
      </button>
      <button
        onClick={() => onCalendarModeChange("week")}
        className={classNames(
          "cw-body-sm cw-py-[3px] cw-w-[70px] cw-cursor-pointer cw-rounded-r-md cw-font-medium",
          {
            [classes.selected]: weekSelected,
            [classes.unselected]: !weekSelected,
          },
        )}
      >
        Week
      </button>
    </div>
  );
};
